import React from "react";
import {Navbar, Title} from "./navbar";
import "./Components.css"
// import Title from "./title";

export default function Heading(props){
    const username = props.username
    const attack = props.attack;
  return (
    <div
      className={`heading-container ${attack ? "attack-active" : ""}`}
      style={{ "--attack-color": attack?.color }}
    >
            <Title/>
            <Navbar username={username}/>
        </div>
    )
}